export enum CasasDecimais {
  UM = 1,
  DOIS = 2,
  TRES = 3,
  QUATRO = 4
}
